// Recon Module Constants

export const VENDOR_TYPES = [
  { value: 'body_shop_outside', label: 'Body Shop - Outside' },
  { value: 'body_shop_inhouse', label: 'Body Shop - In House' },
  { value: 'pdr', label: 'PDR' },
  { value: 'rim_repair', label: 'Rim/Wheel Repair' },
  { value: 'interior_repair', label: 'Interior Repair' },
  { value: 'glass', label: 'Glass' },
  { value: 'upholstery', label: 'Upholstery' },
  { value: 'mechanical_outside', label: 'Mechanical - Outside' },
  { value: 'outside_repair_shop', label: 'Outside Repair Shop' },
  { value: 'detail', label: 'Detail' },
  { value: 'inside_mech', label: 'Inside Mech Work' },
];

// Internal workflow statuses (non-vendor)
export const INTERNAL_STATUSES = [
  { value: 'awaiting_inspection', label: 'Awaiting Inspection' },
  { value: 'chris_to_double_check', label: 'Chris To Double Check' },
  { value: 'parts_ordered', label: 'Parts Ordered' },
  { value: 'repairs_in_progress', label: 'Repairs In Progress' },
  { value: 'at_detail', label: 'At Detail' },
  { value: 'ready_for_sale', label: 'Ready For Sale' },
];

// Vendor workflow statuses (1:1 with RO checkboxes)
export const VENDOR_WORKFLOW_STATUSES = [
  { value: 'needs_pdr', label: 'Needs PDR' },
  { value: 'needs_body_outside', label: 'Needs Body - Outside' },
  { value: 'needs_body_inhouse', label: 'Needs Body - In House' },
  { value: 'needs_rim_wheel', label: 'Needs Rim/Wheel' },
  { value: 'needs_interior', label: 'Needs Interior' },
  { value: 'needs_glass', label: 'Needs Glass' },
  { value: 'needs_mechanical_outside', label: 'Needs Mechanical - Outside' },
  { value: 'needs_inside_mech', label: 'Needs Inside Mech Work' },
  { value: 'need_new_vendor', label: 'Need To Find New Vendor' },
];

// Combined for backward compatibility
export const WORKFLOW_STATUSES = [...INTERNAL_STATUSES, ...VENDOR_WORKFLOW_STATUSES];

export const APPROVAL_THRESHOLD = 600;
export const INTERNAL_RATE = 26;  // Cost to us per hour
export const LABOR_RATE = 35;     // What we bill per hour (shop profit)
export const MARKUP_RATE = 40;

export const RO_STATUSES = [
  { value: 'open', label: 'Open', color: 'blue' },
  { value: 'pending_delivery', label: 'Pending Delivery', color: 'slate' },
  { value: 'in_progress', label: 'In Progress', color: 'yellow' },
  { value: 'waiting_parts', label: 'Waiting Parts', color: 'orange' },
  { value: 'waiting_approval', label: 'Waiting Approval', color: 'purple' },
  { value: 'waiting_vendor', label: 'Waiting Vendor', color: 'pink' },
  { value: 'complete', label: 'Complete', color: 'green' },
  { value: 'closed', label: 'Closed', color: 'gray' },
];

export const PART_STATUSES = [
  { value: 'needed', label: 'Needed' },
  { value: 'ordered', label: 'Ordered' },
  { value: 'shipped', label: 'Shipped' },
  { value: 'arrived', label: 'Arrived' },
  { value: 'installed', label: 'Installed' },
];

export const VENDOR_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'complete', label: 'Complete' },
];

export const SALE_DESTINATIONS = [
  { value: 'byrider', label: 'Byrider' },
  { value: 'acv_openlane', label: 'ACV / OpenLane' },
  { value: 'americas_toledo', label: 'Americas Toledo' },
];
